import React, {useCallback} from "react"
import {Box, Stack, Typography} from "@mui/material"
import {getOptions} from "../../misc/widget-functions"
import InfoIcon from "../../components/general/infoIcon"
import Content from "../../components/Content"

export const containerColoredBoxPrototype = [
        {
          "key": "infotext",
          "type": "STRING",
          "label": "infotext",
          "size": 6
        }
      ]

const ColoredBoxContainer = ({container, triggerAction, getDataFromPointer}) => {
    const {connections} = container
    const options = getOptions(container)
    const value = getDataFromPointer(connections?.origin?.pointer) ?? []

    const displayValue = options?.find((option) =>
        _.isEqual(option.value, value),
    )?.label
    const color = container.subtext ?? "#ff0000"
    const title = container.text
    const infoText = container.infotext

    const onClick = useCallback(
        () => container?.action && triggerAction(container?.action, value),
        [triggerAction, container, value],
    )

    return (
        <Box
            onClick={container?.action ? onClick : () => {}}
            sx={{cursor: container?.action ? "pointer" : "default"}}
            border="2px solid black"
            borderColor={color}
            borderRadius="8px"
            position="relative"
            py={1}
            px={2}>
            <Stack spacing={1}>
                {(title || infoText) && (
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography
                            color={color}
                            variant="h6"
                            fontWeight="bolder"
                        >
                            {displayValue ? displayValue : title}
                        </Typography>

                        {infoText && <InfoIcon infoText={infoText} color={color}/>}
                    </Box>
                )}

                {container.children.map((child) => (
                    <Content
                        key={child.id}
                        child={child}
                        disabled={child.disabled}
                    />
                ))}
            </Stack>
        </Box>
    )
}

export default ColoredBoxContainer
